module.exports = __webpack_public_path__ + "img/background-cert-cloud.2f2196d9.png";